import { render, staticRenderFns } from "./AIWritingListComp.vue?vue&type=template&id=5a789540&scoped=true"
import script from "./AIWritingListComp.vue?vue&type=script&lang=js"
export * from "./AIWritingListComp.vue?vue&type=script&lang=js"
import style0 from "./AIWritingListComp.vue?vue&type=style&index=0&id=5a789540&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a789540",
  null
  
)

export default component.exports